<template>
  <div :class="classes">
    <pt-page-title title="账户额度管理详情"></pt-page-title>
    <pt-sub-title title="账户额度信息"></pt-sub-title>
    <template>
      <div :class="$style['pt-balance-detail']">
        <table>
          <tr>
            <td>事业部：</td>
            <td>{{detail.departmentName?detail.departmentName:'--'}}</td>
          </tr>
          <tr>
            <td>操作类型：</td>
            <td>{{detail.changeOperationType}}</td>
          </tr>
          <tr>
            <td>金额：</td>
            <td>{{detail.balance_show}}</td>
          </tr>
          <tr>
            <td>内容/原因：</td>
            <td>{{detail.content_show?detail.content_show:'--'}}</td>
          </tr>
          <tr>
            <td>财务用户：</td>
            <td>{{detail.operatorName?detail.operatorName:'--'}}</td>
          </tr>
          <tr>
            <td>操作时间：</td>
            <td>{{detail.operate_time?detail.operate_time:'--'}}</td>
          </tr>
        </table>
      </div>
      <el-button type="primary" @click="goEdit(detail)">编辑</el-button>
      <el-button type="danger" @click="goDelete(detail.id)">删除</el-button>
      <enter-amount-dialog :dialogVisible="showDialog" @close="closeDialog" :departmentList="departmentList" :editAmount="editAmount" :isEdit="isEdit">
      </enter-amount-dialog>
    </template>
  </div>
</template>

<script>
// 组件class前缀
import enterAmountDialog from '../enter-amount-dialog'
import { cashCount } from '@/utils/formUtils'
const prefixCls = 'pt-balance-detail'

export default {
  name: 'pt-balance-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    departmentList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    enterAmountDialog
  },
  data () {
    return {
      showDialog: false,
      editAmount: {},
      isEdit: false
    }
  },
  methods: {
    closeDialog (val) {
      if (val) {
        this.$emit('getBalanceDetail')
      }
      this.showDialog = false
    },
    cashCount,
    goEdit (val) {
      this.editAmount = val
      this.isEdit = true
      this.showDialog = true
    },
    goDelete (id) {
      this.$confirm('您确定删除该额度信息吗？', '删除额度信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$emit('deleteBalanceDetail', id)
      })
    }
  }

}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  @import "~less/var.less";
  .pt-balance-detail {
    padding: 50px 0;
    display: flex;
    flex-direction: row;

    :global table {
      tr {
        td {
          line-height: 40px;
          font-size: 16px;
        }

        :first-child {
          width: 1rem;
          display: -webkit-box;
          color: @mainColor;
          justify-content: flex-end;
        }
      }
    }

    .el-checkbox+.el-checkbox {
      margin: 0
    }
  }

</style>
